<template>
  <!-- 活动管理 -->
  <div class="activityListbox">
    <div class="activity_title">
      <div class="title_icon">
        <div class="todayNum">{{ todayNum }}</div>
        <div class="tips">今日招募</div>
      </div>
      <div class="title_content">
        <div class="title">会员招募小部件<img class="hot" src="../../assets/images/liveCard_hot.png" alt=""></div>
        <div class="content">会员招募小部件是可以装修店铺首页的一种功能，用户点击首页中的小部件区域即可完成入会与优惠权益方法，比官方会员中心页入会提高66%的入会率</div>
        <div class="teach" @click="openTeach">查看教程</div>
      </div>
    </div>

    <el-tabs v-model="activeName">
      <el-tab-pane label="招募模板" name="first">
        <!-- m模板图 -->
        <div class="templateBox">
          <!-- 定制 -->
          <!-- <div class="temImg">
        <div class="temImg_content" @click="handleOpen()" style="border: 1px solid rgba(38,112,251,0.5000);">
          <div class="temImg_content_img temImg_dz">
            <div class="temImg_dz_center">
              <img src="@/assets/thdImg/pages/dz.svg" alt="" />
              <span>品牌定制</span>
            </div>
          </div>
          <div class="temImg_content_wz" style="background: rgba(38, 112, 251, 0.05);"></div>
        </div>
      </div> -->
          <!-- 模板 -->
          <div class="temImg">
            <div class="temImg_content">
              <div class="temImg_content_img">
                <img v-if="type === 1" class="temImg_content_img_div" src="../../assets/images/liveCard/used.png"
                  alt="" />
                <img style="width:100%;max-height: 380px;" src="../../assets/images/liveCard/zero-board.png" alt="" />
              </div>
              <div class="temImg_content_wz">
                <span class="temImg_title">0元入会招募小部件</span>
                <!-- <span class="temImg_desc">模板ID：</span> -->
              </div>
            </div>
            <!-- hover -->
            <div class="temImg_content_bgshadow">
              <!-- <div class="temImg_content_bgshadow_code qrCodeIMG" id="qrCodeIMG1" ref="qrCodeIMG1"></div> -->
              <div class="temImg_content_bgshadow_btn pointer" @click="userBoard(1)">使用此模板</div>
              <div class="temImg_content_bgshadow_codeDesc pointer" @click="goToActive(1)">编辑</div>
            </div>
          </div>

          <div class="temImg">
            <div class="temImg_content">
              <div class="temImg_content_img">
                <img v-if="type === 2" class="temImg_content_img_div" src="../../assets/images/liveCard/used.png"
                  alt="" />
                <img style="width:100%;max-height: 380px;" src="../../assets/images/liveCard/one-board.png" alt="" />
              </div>
              <div class="temImg_content_wz">
                <span class="temImg_title">1分钱入会招募小部件</span>
                <!-- <span class="temImg_desc">模板ID：</span> -->
              </div>
            </div>
            <!-- hover -->
            <div class="temImg_content_bgshadow">
              <!-- <div class="temImg_content_bgshadow_code qrCodeIMG" id="qrCodeIMG1" ref="qrCodeIMG1"></div> -->
              <div class="temImg_content_bgshadow_btn pointer" @click="userBoard(2)">使用此模板</div>
              <div class="temImg_content_bgshadow_codeDesc pointer" @click="goToActive(2)">编辑</div>
            </div>
          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane label="招募统计" name="second">
        <statistic v-if="activeName == 'second'" />
      </el-tab-pane>
      <el-tab-pane label="参与明细" name="third">
        <joinDetail v-if="activeName == 'third'" />
      </el-tab-pane>
    </el-tabs>
    <!-- <router-view></router-view> -->
  </div>
</template>

<script>
import { uploadImage } from "@/api/sellerImageController";
import { getLiveStatusCard, putLiveCard, getTodayNum } from "@/api/liveCard/liveCard";
import statistic from "./component/statistic.vue"
import joinDetail from "./component/joinDetail.vue"
export default {
  components: {
    statistic,
    joinDetail,
  },

  data() {
    return {
      giftList: [
        {
          templateName: "46",
          id: 11,
          templateExampleUrl: "",
        },
      ],
      type: 0,
      activeName: "first",
      todayNum: 0,
    };
  },

  mounted() {
    this.getInfo();
    this.getTodayNum()
  },
  created(){
    this.buriedPoint(1, "云起互动", "首页小部件", "会员招募");
  },
  methods: {
    openTeach() {
      window.open("https://www.yuque.com/yunduanxincrm/sd6oeu/sv3epd")
    },

    async getTodayNum() {
      const res = await getTodayNum()
      this.todayNum = res.data
    },

    getInfo() {
      getLiveStatusCard({}).then(res => {
        // console.log(5555);
        this.type = res.data;
        // console.log(this.type);
      });
    },
    // 使用模板
    userBoard(e) {
      putLiveCard({ type: e }).then(res => {
        // console.log(66669);
        // console.log(res);
        this.$message.success(res.message)
        this.getInfo();
      });
    },
    // 编辑跳转
    goToActive(e) {
      this.$router.push({
        path: "/integralCenter/activeCard",
        query: {
          type: e,
          activityData: e,
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.activityListbox {
  margin: 24px;
  padding: 24px;
  background: #ffffff;
  min-height: calc(100vh - 60px - 48px);
}

.activity_title {
  margin-bottom: 24px;
  color: #000;
  font-size: 18px;
  display: flex;

  .title_icon {
    padding-top: 38px;
    width: 90px;
    height: 90px;
    background-image: url("../../assets/images/liveCard_icon.png");
    background-repeat: no-repeat;
    background-size: 100%;
    text-align: center;

    .tips {
      font-size: 12px;
      transform: scale(0.8);
      color: #666;
      word-spacing: 60px;
    }

    .todayNum {
      margin-bottom: 2px;
      font-weight: 600;
      font-size: 14px;
    }
  }

  .title_content {
    flex: 1;
    margin-left: 16px;

    .title {
      font-size: 16px;
      font-weight: 600;
      color: #333333;
      position: relative;
      display: inline-block;

      .hot {
        position: absolute;
        top: -20px;
        right: -32px;
        height: 30px;
        width: auto;
      }
    }

    .content {
      font-size: 14px;
      color: #666666;
      line-height: 16px;
      margin: 8px 0;
      width: 850px;
    }

    .teach {
      font-size: 14px;
      color: #2670fb;
      cursor: pointer;
      text-decoration: underline;
    }
  }

}

.templateBox {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
}

.temImg {
  width: 250px;
  height: 250px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  margin-right: 41px;

  &:hover .temImg_content_bgshadow {
    opacity: 0;
    animation: key3 0.5s forwards;
  }

  @keyframes key3 {
    0% {
      opacity: 0;
    }

    50% {
      opacity: 0.3;
    }

    100% {
      opacity: 1;
    }
  }

  .temImg_content_bgshadow {
    z-index: 123;
    opacity: 0;
    position: absolute;
    // left: -1;
    top: 0;
    width: 100%;
    height: 214px;
    background: rgba(0, 0, 0, 0.6);
    border-radius: 8px 8px 0px 0px;
    transform: scale(1.05);
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;

    &_code {
      margin: 0 auto;
      margin-top: 125px;
      width: 150px;
      height: 150px;
      background: #ffffff;
      border-radius: 4px;
    }

    &_codeDesc {
      // margin: 0 auto;
      // margin-top: 15px;
      // width: 112px;
      // color: #ffffff;
      margin: 0 auto;
      margin-top: 25px;
      width: 86px;
      height: 32px;
      line-height: 32px;
      text-align: center;
      background: #fff;
      border-radius: 4px;
      color: #2670fb;
      border: 1px solid #2670fb;
    }

    &_btn {
      margin: 0 auto;
      // margin-top: 25px;
      width: 86px;
      height: 32px;
      line-height: 32px;
      text-align: center;
      background: #2670fb;
      border-radius: 4px;
      color: #ffffff;
    }
  }

  &_content {
    width: 100%;
    height: 250px;
    box-sizing: border-box;
    background: #ffffff;
    border-radius: 8px;
    border: 1px solid #dcdfe6;
    transition: 0.6s linear;

    &_img {
      width: 100%;
      height: 214px;
      border-radius: 8px 8px 0px 0px;
      background: #F0F0F0;
      // transition: 0.6s linear;
      display: flex;
      align-items: center;
      justify-content: center;
      position: relative;

      &_div {
        position: absolute;
        top: 0;
        left: 0;
        width: 66px;
        height: 24px;
      }
    }

    &_wz {
      width: 100%;
      height: 53px;
      padding: 10px 12px;
    }
  }

  &:hover {
    .temImg_content {
      box-shadow: 0px 12px 25px 1px rgba(0, 0, 0, 0.15);
      border-radius: 8px;
      transform: scale(1.05);
      transition: transform 0.3s, -webkit-transform 0.3s;
    }
  }

  &_dz {
    width: 100%;
    // height: 433px;
    display: flex;
    justify-content: center;
    align-items: center;

    &_center {
      >img {
        margin: 0 auto;
        display: block;
      }

      >span {
        font-size: 20px;
        font-weight: bold;
        margin-top: 12px;
        display: block;
      }
    }
  }

  &_title {
    display: block;
    color: #333333;
    text-align: center;
  }

  &_desc {
    display: block;
    font-size: 12px;
    line-height: 23px;
    color: #999;
  }
}
</style>
